import React from 'react';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import HeaderBanner from '../../../common/HeaderBanner';
import '../../../../styles/components/create-group.scss';
import { ArrowLeft, Cloud, Loader2, Plus, Trash2, X, FileText, Eye } from 'lucide-react';
import { getUsersByRoles } from '../../../../models/users';
import { getAllOrganization } from '../../../../models/organization';
import { withRouter } from '../../../../hoc/withRouter';
import { toast } from 'react-toastify';
import {
  getCollectionTypes,
  getGroup,
  getPaymentTypes,
  updateGroup,
} from './services/groupServices';
import { PreviewModal } from './components/PreviewModal';

class GroupUpdate extends React.Component {
  constructor() {
    super();
    this.state = {
      organizations: [],
      sectors: [],
      paymentTypes: [],
      collectionTypes: [],
      projectManagers: [],
      safetyOfficers: [],
      organization: '',
      sector_id: 1,
      actual_start_date: '',
      expected_end_date: '',
      project_code: '',
      group_name: '',
      group_name_ar: '',
      manager: '',
      hse: '',
      start_date: '',
      end_date: '',
      reg_start_date: '',
      reg_end_date: '',
      amount: 0,
      visit_amount: 0,
      service_charge: '',
      collection_type: 1,
      payment_type: [],
      is_auctions_grouped: false,
      is_grouped_enroll: false,
      is_extra_time: false,
      extra_time: '2',
      has_auto_bidding: false,
      is_service_charge_included: false,
      is_service_charge_vat_included: false,
      service_charge_included: 0,
      has_auction_update: false,
      auction_status: '',
      enquiryFields: [{ id: Date.now(), label: '', value: '', label_ar: '', value_ar: '' }],
      focal_name: '',
      client_name: '',
      mobile: '',
      email: '',
      country_code: '+968',
      file_group_image: null,
      file_terms: null,
      file_payment_terms: null,
      existing_group_image: null,
      existing_terms: null,
      existing_payment_terms: null,
      previewImage: null,
      showPreview: false,
      isLoading: true,
      hideSidebar: false,
      isSubmitting: false,
      errors: {},
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadInitialData();
  }

  async loadInitialData() {
    this.setState({ isLoading: true });

    try {
      await Promise.all([
        this.loadUsersByRoles(),
        this.loadAllOrganisation(),
        this.loadPaymentTypes(),
        this.loadCollectionTypes(),
      ]);

      const { params } = this.props;
      if (params?.id) {
        await this.loadGroupData(params.id);
      }
    } catch (error) {
      console.error('Error loading initial data:', error);
      toast.error('Failed to load form data');
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async loadGroupData(groupId) {
    try {
      const response = await getGroup(groupId);
      const data = response.data;
      const enquiries = data.enquiry ? JSON.parse(data.enquiry) : [];

      this.setState({
        organization: data.organization,
        sector_id: data.sector_id,
        actual_start_date: data.actual_start_date,
        expected_end_date: data.expected_end_date,
        project_code: data.project_code,
        group_name: data.group_name,
        group_name_ar: data.group_name_ar,
        manager: data.manager,
        hse: data.hse,
        start_date: data.start_date,
        end_date: data.end_date,
        reg_start_date: data.reg_start_date,
        reg_end_date: data.reg_end_date,
        amount: data.amount,
        visit_amount: data.visit_amount,
        service_charge: data.service_charge,
        collection_type: data.collection_type,
        payment_type: data.payment_types?.map((p) => p.id) || [],
        is_auctions_grouped: Boolean(data.is_auctions_grouped),
        is_grouped_enroll: Boolean(data.is_grouped_enroll),
        is_extra_time: Boolean(data.is_extra_time),
        extra_time: data.extra_time,
        has_auto_bidding: Boolean(data.has_auto_bidding),
        is_service_charge_included: Boolean(data.is_service_charge_included),
        service_charge_included: data.service_charge_included,
        enquiryFields:
          enquiries?.length > 0
            ? enquiries.map((e) => ({
              id: Date.now() + Math.random(),
              label: e.label,
              value: e.value,
              label_ar: e.label_ar,
              value_ar: e.value_ar,
            }))
            : [{ id: Date.now(), label: '', value: '', label_ar: '', value_ar: '' }],

        country_code: data.client?.country_code || '+968',
        existing_group_image: data.group_image_url || null,
        existing_terms: data.file_terms || null,
        existing_payment_terms: data.file_payment_terms || null,
        previewImage: data.group_image_url || null,
      });
    } catch (error) {
      console.error('Error loading group data:', error);
      toast.error('Failed to load group details');
    }
  }

  async loadUsersByRoles() {
    try {
      let q = `roles=PM,HSE&is_role_wise=${true}`;
      const response = await getUsersByRoles(q);
      let projectManagers = response.data['PM'] || [];
      let safetyOfficers = response.data['HSE'] || [];
      this.setState({ projectManagers, safetyOfficers });
    } catch (error) {
      console.error('Error loading users:', error);
    }
  }

  async loadAllOrganisation() {
    try {
      const response = await getAllOrganization();
      let organizations = response.data || [];
      this.setState({ organizations });
    } catch (error) {
      console.error('Error loading organizations:', error);
    }
  }



  async loadPaymentTypes() {
    try {
      const response = await getPaymentTypes();
      let paymentTypes = response.data || [];
      this.setState({ paymentTypes });
    } catch (error) {
      console.error('Error loading payment types:', error);
    }
  }

  async loadCollectionTypes() {
    try {
      const response = await getCollectionTypes();
      let collectionTypes = response.data || [];
      this.setState({ collectionTypes });
    } catch (error) {
      console.error('Error loading collection types:', error);
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });

    if (this.state.errors[name]) {
      this.setState((prevState) => ({
        errors: { ...prevState.errors, [name]: '' },
      }));
    }
  };

  handleToggle = (field) => {
    this.setState((prevState) => ({ [field]: !prevState[field] }));
  };

  handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      this.setState({ [name]: files[0] });

      // Create preview for image files
      if (name === 'file_group_image' && files[0].type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.setState({ previewImage: reader.result });
        };
        reader.readAsDataURL(files[0]);
      }

      if (this.state.errors[name]) {
        this.setState((prevState) => ({
          errors: { ...prevState.errors, [name]: '' },
        }));
      }
    }
  };

  removeFile = (fileType) => {
    if (fileType === 'image') {
      this.setState({
        file_group_image: null,
        previewImage: this.state.existing_group_image,
      });
    } else if (fileType === 'terms') {
      this.setState({ file_terms: null });
    } else if (fileType === 'payment_terms') {
      this.setState({ file_payment_terms: null });
    }
  };

  removeExistingFile = (fileType) => {
    if (fileType === 'image') {
      this.setState({
        existing_group_image: null,
        previewImage: null,
      });
    } else if (fileType === 'terms') {
      this.setState({ existing_terms: null });
    } else if (fileType === 'payment_terms') {
      this.setState({ existing_payment_terms: null });
    }
  };

  downloadFile = (fileUrl, fileName) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  addEnquiryField = () => {
    const { enquiryFields } = this.state;
    const lastEntry = enquiryFields[enquiryFields.length - 1];
    if (!lastEntry.label || !lastEntry.value) {
      toast.info('Please complete the current entry before adding a new one.');
      return;
    }

    this.setState((prevState) => ({
      enquiryFields: [
        ...prevState.enquiryFields,
        { id: Date.now(), label: '', value: '', label_ar: '', value_ar: '' },
      ],
    }));
  };

  removeEnquiryField = (index) => {
    const { enquiryFields } = this.state;

    if (enquiryFields.length <= 1) {
      toast.info('At least one enquiry section entry is required.');
      return;
    }
    this.setState((prevState) => ({
      enquiryFields: prevState.enquiryFields.filter((_, i) => i !== index),
    }));
  };

  handleEnquiryChange = (index, field, value) => {
    const updatedFields = [...this.state.enquiryFields];
    updatedFields[index][field] = value;
    this.setState({ enquiryFields: updatedFields });
  };

  handleCheckboxChange = (e) => {
    const value = Number(e.target.value);
    const { checked } = e.target;

    this.setState((prevState) => {
      let payment_type = [...prevState.payment_type];

      if (checked) {
        payment_type.push(value);
      } else {
        payment_type = payment_type.filter((item) => item !== value);
      }

      return {
        payment_type,
        errors: { ...prevState.errors, payment_type: '' },
      };
    });
  };

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  validateForm = () => {
    const errors = {};

    if (!this.state.organization) errors.organization = 'Organization is required';
    if (!this.state.sector_id) errors.sector_id = 'Sector is required';
    if (!this.state.actual_start_date) errors.actual_start_date = 'Actual Start Date is required';
    if (!this.state.expected_end_date) errors.expected_end_date = 'Expected End Date is required';
    if (!this.state.project_code) errors.project_code = 'Project Code is required';
    if (!this.state.group_name) errors.group_name = 'Group Name (English) is required';
    if (!this.state.group_name_ar) errors.group_name_ar = 'Group Name (Arabic) is required';
    if (!this.state.manager) errors.manager = 'Project Manager is required';
    if (!this.state.hse) errors.hse = 'Safety Officer is required';
    if (!this.state.start_date) errors.start_date = 'Start Date is required';
    if (!this.state.end_date) errors.end_date = 'End Date is required';
    if (!this.state.reg_start_date) errors.reg_start_date = 'Reg Start Date is required';
    if (!this.state.reg_end_date) errors.reg_end_date = 'Reg End Date is required';
    if (!this.state.service_charge) errors.service_charge = 'Service Charge is required';
    if (!this.state.amount) {
      errors.amount = 'Enroll Amount is required';
    } else if (parseFloat(this.state.amount) < 0) {
      errors.amount = 'Amount must be greater than or equal to 0';
    }

    if (this.state.is_extra_time && !this.state.extra_time) {
      errors.extra_time = 'Extra Time is required';
    }

    if (this.state.is_service_charge_included && !this.state.service_charge_included) {
      errors.service_charge_included = 'Service charge Included is required';
    }

    if (!this.state.collection_type) errors.collection_type = 'Collection Type is required';
    if (this.state.payment_type.length === 0)
      errors.payment_type = 'At least one Payment Type is required';


    if (!this.state.file_group_image && !this.state.existing_group_image) {
      errors.file_group_image = 'Group Image is required';
    } else if (this.state.file_group_image && this.state.file_group_image.size > 10 * 1024 * 1024) {
      errors.file_group_image = 'File size must be less than 10MB';
    }

    if (!this.state.file_terms && !this.state.existing_terms) {
      errors.file_terms = 'Terms & Conditions file is required';
    } else if (this.state.file_terms && this.state.file_terms.size > 10 * 1024 * 1024) {
      errors.file_terms = 'File size must be less than 10MB';
    }

    if (!this.state.file_payment_terms && !this.state.existing_payment_terms) {
      errors.file_payment_terms = 'Payment Terms file is required';
    } else if (
      this.state.file_payment_terms &&
      this.state.file_payment_terms.size > 10 * 1024 * 1024
    ) {
      errors.file_payment_terms = 'File size must be less than 10MB';
    }

    if (this.state.expected_end_date && this.state.actual_start_date) {
      if (new Date(this.state.expected_end_date) < new Date(this.state.actual_start_date)) {
        errors.expected_end_date = 'Expected End Date must be after Actual Start Date';
      }
    }

    if (this.state.end_date && this.state.start_date) {
      if (new Date(this.state.end_date) < new Date(this.state.start_date)) {
        errors.end_date = 'Auction End Date must be after Auction Start Date';
      }
    }

    if (this.state.reg_end_date && this.state.reg_start_date) {
      if (new Date(this.state.reg_end_date) < new Date(this.state.reg_start_date)) {
        errors.reg_end_date = 'Registration End Date must be after Registration Start Date';
      }
    }

    if (this.state.visit_amount && parseFloat(this.state.visit_amount) < 0) {
      errors.visit_amount = 'Amount must be greater than or equal to 0';
    }

    if (this.state.service_charge && parseFloat(this.state.service_charge) < 0) {
      errors.service_charge = 'Service Charge must be greater than or equal to 0';
    }

    if (this.state.extra_time && parseFloat(this.state.extra_time) < 0) {
      errors.extra_time = 'Extra Time must be greater than or equal to 0';
    }

    this.setState({ errors });

    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      const element =
        document.querySelector(`[name="${firstErrorField}"]`) ||
        document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }

    return true;
  };

  handleSubmit = async () => {
    if (!this.validateForm()) {
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const formData = new FormData();

      formData.append('organization', this.state.organization);
      formData.append('sector_id', this.state.sector_id);
      formData.append('actual_start_date', this.state.actual_start_date);
      formData.append('expected_end_date', this.state.expected_end_date);
      formData.append('project_code', this.state.project_code);
      formData.append('group_name', this.state.group_name);
      formData.append('group_name_ar', this.state.group_name_ar);
      formData.append('manager', this.state.manager);
      formData.append('hse', this.state.hse);
      formData.append('start_date', this.state.start_date);
      formData.append('end_date', this.state.end_date);
      formData.append('reg_start_date', this.state.reg_start_date);
      formData.append('reg_end_date', this.state.reg_end_date);
      formData.append('is_auctions_grouped', this.state.is_auctions_grouped ? '1' : '0');
      formData.append('is_grouped_enroll', this.state.is_grouped_enroll ? '1' : '0');
      formData.append('is_extra_time', this.state.is_extra_time ? '1' : '0');
      formData.append('has_auto_bidding', this.state.has_auto_bidding ? '1' : '0');
      formData.append(
        'is_service_charge_included',
        this.state.is_service_charge_included ? '1' : '0'
      );
      if (this.state.is_service_charge_included && this.state.service_charge_included)
        formData.append('service_charge_included', this.state.service_charge_included);
      formData.append(
        'is_service_charge_vat_included',
        this.state.is_service_charge_vat_included ? '1' : '0'
      );

      if (this.state.is_extra_time && this.state.extra_time)
        formData.append('extra_time', this.state.extra_time);
      formData.append('amount', this.state.amount);
      formData.append('has_auction_update', this.state.has_auction_update ? '1' : '0');
      if (this.state.auction_status) formData.append('auction_status', this.state.auction_status);
      if (this.state.visit_amount) formData.append('visit_amount', this.state.visit_amount);
      if (this.state.service_charge) formData.append('service_charge', this.state.service_charge);

      formData.append('collection_type', this.state.collection_type);

      this.state.payment_type.forEach((type, index) => {
        formData.append(`payment_type[${index}]`, type);
      });

      const validEnquiries = this.state.enquiryFields.filter(
        (field) => field.label.trim() && field.value.trim()
      );
      if (validEnquiries.length > 0) {
        validEnquiries.forEach((enquiry, index) => {
          formData.append(`enquiries[${index}][label]`, enquiry.label);
          formData.append(`enquiries[${index}][value]`, enquiry.value);
          if (enquiry.label_ar) formData.append(`enquiries[${index}][label_ar]`, enquiry.label_ar);
          if (enquiry.value_ar) formData.append(`enquiries[${index}][value_ar]`, enquiry.value_ar);
        });
      }

      formData.append('client[country_code]', this.state.country_code);

      if (this.state.file_group_image)
        formData.append('files[file_group_image]', this.state.file_group_image);
      if (this.state.file_terms) formData.append('files[file_terms]', this.state.file_terms);
      if (this.state.file_payment_terms)
        formData.append('files[file_payment_terms]', this.state.file_payment_terms);

      const response = await updateGroup(this.props.params.id, formData);

      if (response.success) {
        toast.success('Group updated successfully!');
        this.props.navigate('/groups');
      } else {
        if (response.errors) {
          const apiErrors = {};
          if (typeof response.errors === 'object') {
            Object.keys(response.errors).forEach((key) => {
              apiErrors[key] = Array.isArray(response.errors[key])
                ? response.errors[key][0]
                : response.errors[key];
            });
          }
          this.setState({ errors: apiErrors });
        } else {
          toast.error('Error updating group: ' + (response.message || 'Unknown error'));
        }
      }
    } catch (error) {
      console.error('Error updating group:', error);
      toast.error('Error updating group: ' + (error.message || 'Unknown error'));
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleCancel = () => {
    this.props.navigate('/groups');
  };

  renderFieldError = (fieldName) => {
    if (this.state.errors[fieldName]) {
      return <div className="field-error">{this.state.errors[fieldName]}</div>;
    }
    return null;
  };

  getFileInfo = (file) => {
    if (!file) return null;

    // File object
    if (file instanceof File) {
      return {
        fileName: file.name,
        extension: file.name.split('.').pop(),
        size: file.size, // bytes
        sizeKB: (file.size / 1024).toFixed(2),
        sizeMB: (file.size / (1024 * 1024)).toFixed(2),
      };
    }

    // URL / path string (size not available)
    const fileName = file.split('/').pop();
    const extension = fileName.split('.').pop();

    return {
      fileName,
      extension,
      size: null,
    };
  };

  renderLoadingSkeleton = () => {
    return (
      <div className="create-group-container">
        <div className="form-content">
          <div className="left-column">
            {/* Group Info Section Skeleton */}
            <div className="form-section">
              <div
                className="skeleton skeleton-title"
                style={{ width: '120px', marginBottom: '24px' }}
              ></div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '100px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '80px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '130px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '140px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '100px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '150px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '110px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '100px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '100px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '160px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field full-width">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '170px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
            </div>

            {/* Auction Details Section Skeleton */}
            <div className="form-section">
              <div
                className="skeleton skeleton-title"
                style={{ width: '150px', marginBottom: '24px' }}
              ></div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '130px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '120px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '180px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '170px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '150px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '140px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
            </div>

            {/* Enquiry Section Skeleton */}
            <div className="form-section">
              <div className="section-header">
                <div className="skeleton skeleton-title" style={{ width: '140px' }}></div>
                <div
                  className="skeleton skeleton-button"
                  style={{ width: '100px', height: '40px' }}
                ></div>
              </div>
              <div className="enquiry-item">
                <div className="form-row">
                  <div className="form-field">
                    <div
                      className="skeleton skeleton-label"
                      style={{ width: '60px', marginBottom: '8px' }}
                    ></div>
                    <div className="skeleton skeleton-input"></div>
                  </div>
                  <div className="form-field">
                    <div
                      className="skeleton skeleton-label"
                      style={{ width: '60px', marginBottom: '8px' }}
                    ></div>
                    <div className="skeleton skeleton-input"></div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <div
                      className="skeleton skeleton-label"
                      style={{ width: '100px', marginBottom: '8px' }}
                    ></div>
                    <div className="skeleton skeleton-input"></div>
                  </div>
                  <div className="form-field">
                    <div
                      className="skeleton skeleton-label"
                      style={{ width: '100px', marginBottom: '8px' }}
                    ></div>
                    <div className="skeleton skeleton-input"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="right-column">
            {/* Financial Details Section Skeleton */}
            <div className="form-section">
              <div
                className="skeleton skeleton-title"
                style={{ width: '140px', marginBottom: '24px' }}
              ></div>
              <div className="form-field form-field-margin-bottom">
                <div
                  className="skeleton skeleton-label"
                  style={{ width: '120px', marginBottom: '8px' }}
                ></div>
                <div className="skeleton skeleton-input"></div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '110px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '130px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '150px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
                <div className="form-field">
                  <div
                    className="skeleton skeleton-label"
                    style={{ width: '140px', marginBottom: '8px' }}
                  ></div>
                  <div className="skeleton skeleton-input"></div>
                </div>
              </div>
              <div className="form-field form-field-margin-bottom">
                <div
                  className="skeleton skeleton-label"
                  style={{ width: '180px', marginBottom: '8px' }}
                ></div>
                <div className="skeleton skeleton-input"></div>
              </div>
              <div className="form-field form-field-margin-bottom">
                <div
                  className="skeleton skeleton-label"
                  style={{ width: '120px', marginBottom: '8px' }}
                ></div>
                <div className="skeleton skeleton-checkbox-group" style={{ height: '80px' }}></div>
              </div>
            </div>

            {/* Configurations Section Skeleton */}
            <div className="form-section">
              <div
                className="skeleton skeleton-title"
                style={{ width: '200px', marginBottom: '24px' }}
              ></div>
              {[1, 2].map((item) => (
                <div key={item} className="toggle-field">
                  <div className="skeleton skeleton-label" style={{ width: '140px' }}></div>
                  <div className="skeleton skeleton-toggle"></div>
                </div>
              ))}
              <div className="upload-field" style={{ marginTop: '24px' }}>
                <div
                  className="skeleton skeleton-label"
                  style={{ width: '160px', marginBottom: '8px' }}
                ></div>
                <div className="skeleton skeleton-upload-area"></div>
              </div>
              <div className="upload-field">
                <div
                  className="skeleton skeleton-label"
                  style={{ width: '200px', marginBottom: '8px' }}
                ></div>
                <div className="skeleton skeleton-upload-area"></div>
              </div>
              <div className="upload-field">
                <div
                  className="skeleton skeleton-label"
                  style={{ width: '180px', marginBottom: '8px' }}
                ></div>
                <div className="skeleton skeleton-upload-area"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons-l2 border-top-light">
          <div
            className="skeleton skeleton-button"
            style={{ width: '100px', height: '44px' }}
          ></div>
          <div
            className="skeleton skeleton-button"
            style={{ width: '140px', height: '44px' }}
          ></div>
        </div>
      </div>
    );
  };

  render() {
    const {
      organizations,
      sectors,
      paymentTypes,
      collectionTypes,
      projectManagers,
      safetyOfficers,
      isLoading,
      previewImage,
      showPreview,
    } = this.state;

    const isArabic = i18n.language === 'ar';

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('edit_group')} subtitle={i18n.t('edit_group_subtitle')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => this.setState({ hideSidebar: !this.state.hideSidebar })}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() => this.props.navigate(`/groups`)}
                        disabled={isLoading}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t('back')}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    {isLoading ? (
                      this.renderLoadingSkeleton()
                    ) : (
                      <div className="create-group-container">
                        <div className="form-content">
                          <div className="left-column">
                            <div className="form-section">
                              <h2>{i18n.t('group_info')}</h2>
                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t('client_name')} *</label>
                                  <select
                                    name="organization"
                                    value={this.state.organization}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.organization ? 'error' : ''}
                                  >
                                    <option value="">{i18n.t('select_client')}</option>
                                    {organizations.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.organization_name}
                                      </option>
                                    ))}
                                  </select>
                                  {this.renderFieldError('organization')}
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t('sector')} *</label>
                                  <select
                                    name="sector_id"
                                    value={this.state.sector_id}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.sector_id ? 'error' : ''}
                                  >
                                    <option value="">{i18n.t('select_sector')}</option>
                                    {sectors.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {isArabic ? item.name_ar : item.name}
                                      </option>
                                    ))}
                                  </select>
                                  {this.renderFieldError('sector_id')}
                                </div>
                              </div>
                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t('actual_start_date')} *</label>
                                  <input
                                    type="date"
                                    name="actual_start_date"
                                    value={this.state.actual_start_date}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.actual_start_date ? 'error' : ''}
                                  />
                                  {this.renderFieldError('actual_start_date')}
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t('expected_end_date')} *</label>
                                  <input
                                    type="date"
                                    name="expected_end_date"
                                    value={this.state.expected_end_date}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.expected_end_date ? 'error' : ''}
                                  />
                                  {this.renderFieldError('expected_end_date')}
                                </div>
                              </div>



                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t('project_code')} *</label>
                                  <input
                                    type="text"
                                    name="project_code"
                                    value={this.state.project_code}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter project code"
                                    className={this.state.errors.project_code ? 'error' : ''}
                                  />
                                  {this.renderFieldError('project_code')}
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t('group_name')} (English) *</label>
                                  <input
                                    type="text"
                                    name="group_name"
                                    value={this.state.group_name}
                                    onChange={this.handleInputChange}
                                    placeholder="Enter group name"
                                    className={this.state.errors.group_name ? 'error' : ''}
                                  />
                                  {this.renderFieldError('group_name')}
                                </div>
                              </div>
                              <div className="form-row">
                                <div className="form-field full-width">
                                  <label>{i18n.t('group_name')} (العربية) *</label>
                                  <input
                                    type="text"
                                    name="group_name_ar"
                                    value={this.state.group_name_ar}
                                    onChange={this.handleInputChange}
                                    placeholder="أدخل اسم المجموعة"
                                    dir="rtl"
                                    className={this.state.errors.group_name_ar ? 'error' : ''}
                                  />
                                  {this.renderFieldError('group_name_ar')}
                                </div>
                              </div>
                            </div>

                            <div className="form-section">
                              <h2>{i18n.t('auction_details')}</h2>
                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t('project_manager')} *</label>
                                  <select
                                    name="manager"
                                    value={this.state.manager}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.manager ? 'error' : ''}
                                  >
                                    <option value="">{i18n.t('select_project_manager')}</option>
                                    {projectManagers.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                  {this.renderFieldError('manager')}
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t('safety_officer')} *</label>
                                  <select
                                    name="hse"
                                    value={this.state.hse}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.hse ? 'error' : ''}
                                  >
                                    <option value="">{i18n.t('select_safety_manager')}</option>
                                    {safetyOfficers.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                  {this.renderFieldError('hse')}
                                </div>
                              </div>
                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t('auction_reg_start_date')} *</label>
                                  <input
                                    type="datetime-local"
                                    name="reg_start_date"
                                    value={this.state.reg_start_date}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.reg_start_date ? 'error' : ''}
                                  />
                                  {this.renderFieldError('reg_start_date')}
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t('auction_reg_end_date')} *</label>
                                  <input
                                    type="datetime-local"
                                    name="reg_end_date"
                                    value={this.state.reg_end_date}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.reg_end_date ? 'error' : ''}
                                  />
                                  {this.renderFieldError('reg_end_date')}
                                </div>
                              </div>
                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t('auction_start_date')} *</label>
                                  <input
                                    type="datetime-local"
                                    name="start_date"
                                    value={this.state.start_date}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.start_date ? 'error' : ''}
                                  />
                                  {this.renderFieldError('start_date')}
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t('auction_end_date')} *</label>
                                  <input
                                    type="datetime-local"
                                    name="end_date"
                                    value={this.state.end_date}
                                    onChange={this.handleInputChange}
                                    className={this.state.errors.end_date ? 'error' : ''}
                                  />
                                  {this.renderFieldError('end_date')}
                                </div>
                              </div>
                            </div>

                            <div className="form-section">
                              <div className="section-header">
                                <h2>{i18n.t('enquiry_section')}</h2>
                                <button
                                  className="button1 button1-secondary"
                                  onClick={this.addEnquiryField}
                                  type="button"
                                >
                                  <Plus size={18} /> {i18n.t('add_new')}
                                </button>
                              </div>
                              {this.state.enquiryFields.map((field, index) => (
                                <div key={field.id} className="enquiry-item">
                                  <div className="form-row">
                                    <div className="form-field">
                                      <label>{i18n.t('label')} *</label>
                                      <input
                                        type="text"
                                        value={field.label}
                                        onChange={(e) =>
                                          this.handleEnquiryChange(index, 'label', e.target.value)
                                        }
                                        placeholder="e.g. Location"
                                      />
                                    </div>
                                    <div className="form-field">
                                      <label>{i18n.t('value')} *</label>
                                      <input
                                        type="text"
                                        value={field.value}
                                        onChange={(e) =>
                                          this.handleEnquiryChange(index, 'value', e.target.value)
                                        }
                                        placeholder="e.g. Muscat"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-row">
                                    <div className="form-field">
                                      <label>{i18n.t('label')} (العربية)</label>
                                      <input
                                        type="text"
                                        value={field.label_ar}
                                        onChange={(e) =>
                                          this.handleEnquiryChange(
                                            index,
                                            'label_ar',
                                            e.target.value
                                          )
                                        }
                                        placeholder="e.g. الموقع"
                                        dir="rtl"
                                      />
                                    </div>
                                    <div className="form-field">
                                      <label>{i18n.t('value')} (العربية)</label>
                                      <input
                                        type="text"
                                        value={field.value_ar}
                                        onChange={(e) =>
                                          this.handleEnquiryChange(
                                            index,
                                            'value_ar',
                                            e.target.value
                                          )
                                        }
                                        placeholder="e.g. مسقط"
                                        dir="rtl"
                                      />
                                    </div>
                                  </div>
                                  {this.state.enquiryFields.length > 1 && (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-end',
                                      }}
                                    >
                                      <button
                                        className="button1 button1-danger"
                                        onClick={() => this.removeEnquiryField(index)}
                                        type="button"
                                      >
                                        <Trash2 size={18} />
                                        {i18n.t('remove')}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>

                            <div className="form-section">
                              <h2>{i18n.t('does_the_auctions_need_an_update')}</h2>
                              <div className="form-field">
                                <label>{i18n.t('auction_status')}</label>
                                <select
                                  name="auction_status"
                                  value={this.state.auction_status}
                                  onChange={this.handleInputChange}
                                  className={this.state.errors.auction_status ? 'error' : ''}
                                >
                                  <option value="">{i18n.t('auction_status')}</option>
                                  <option value="E">{i18n.t('expired')}</option>
                                  <option value="A">{i18n.t('active')}</option>
                                </select>
                                {this.renderFieldError('auction_status')}
                              </div>
                              <div className="toggle-field">
                                <label>{i18n.t('update_auctions')}</label>
                                <div
                                  className={`toggle ${this.state.has_auction_update ? 'active' : ''
                                    }`}
                                  onClick={() => this.handleToggle('has_auction_update')}
                                >
                                  <div className="toggle-slider"></div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="right-column">
                            <div className="form-section">
                              <h2>{i18n.t('financial_details')}</h2>
                              <div className="form-field form-field-margin-bottom">
                                <label>{i18n.t('collection_type')} *</label>
                                <select
                                  name="collection_type"
                                  value={this.state.collection_type}
                                  onChange={this.handleInputChange}
                                  className={this.state.errors.collection_type ? 'error' : ''}
                                >
                                  <option value="">{i18n.t('select_collection_type')}</option>
                                  {collectionTypes.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {isArabic ? item.name_ar : item.name}
                                    </option>
                                  ))}
                                </select>
                                {this.renderFieldError('collection_type')}
                              </div>
                              <div className="form-row">
                                <div className="form-field">
                                  <label>{i18n.t('enroll_amount')} *</label>
                                  <input
                                    type="number"
                                    name="amount"
                                    value={this.state.amount}
                                    onChange={this.handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="0.00"
                                    step="0.01"
                                    min="0"
                                    className={this.state.errors.amount ? 'error' : ''}
                                  />
                                  {this.renderFieldError('amount')}
                                </div>
                                <div className="form-field">
                                  <label>{i18n.t('site_visit_amount')}</label>
                                  <input
                                    type="number"
                                    name="visit_amount"
                                    value={this.state.visit_amount}
                                    onChange={this.handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="0.00"
                                    step="0.01"
                                    min="0"
                                    className={this.state.errors.visit_amount ? 'error' : ''}
                                  />
                                  {this.renderFieldError('visit_amount')}
                                </div>
                              </div>
                              <div className="form-row">


                                <div className="form-field">
                                  <label>{i18n.t('service_charge')} (%) *</label>
                                  <input
                                    type="text"
                                    name="service_charge"
                                    value={this.state.service_charge}
                                    onChange={this.handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="e.g. 5 or 5%"
                                    step="0.01"
                                    min="0"
                                    className={this.state.errors.service_charge ? 'error' : ''}
                                  />
                                  {this.renderFieldError('service_charge')}
                                </div>
                              </div>

                              <div className="form-field form-field-margin-bottom">
                                <label>{i18n.t('payment_type')} *</label>
                                <div className="payment-type-group">
                                  {paymentTypes.map((item) => (
                                    <label className="payment-checkbox" key={item.id}>
                                      <input
                                        type="checkbox"
                                        name="payment_type"
                                        value={item.id}
                                        checked={this.state.payment_type.includes(item.id)}
                                        onChange={this.handleCheckboxChange}
                                      />
                                      <span>{isArabic ? item.name_ar : item.name}</span>
                                    </label>
                                  ))}
                                </div>
                                {this.renderFieldError('payment_type')}
                              </div>
                            </div>

                            <div className="form-section">
                              <h2>{i18n.t('config_and_uploads')}</h2>
                              <div className="toggle-field">
                                <label>{i18n.t('grouped_auction')}</label>
                                <div
                                  className={`toggle ${this.state.is_auctions_grouped ? 'active' : ''
                                    }`}
                                  onClick={() => this.handleToggle('is_auctions_grouped')}
                                >
                                  <div className="toggle-slider"></div>
                                </div>
                              </div>
                              <div className="toggle-field">
                                <label>{i18n.t('grouped_enroll')}</label>
                                <div
                                  className={`toggle ${this.state.is_grouped_enroll ? 'active' : ''
                                    }`}
                                  onClick={() => this.handleToggle('is_grouped_enroll')}
                                >
                                  <div className="toggle-slider"></div>
                                </div>
                              </div>
                              <div className="toggle-field">
                                <label>{i18n.t('auto_biding')}</label>
                                <div
                                  className={`toggle ${this.state.has_auto_bidding ? 'active' : ''
                                    }`}
                                  onClick={() => this.handleToggle('has_auto_bidding')}
                                >
                                  <div className="toggle-slider"></div>
                                </div>
                              </div>
                              <div className="toggle-field">
                                <label>{i18n.t('service_charge_included')}</label>
                                <div
                                  className={`toggle ${this.state.is_service_charge_included ? 'active' : ''
                                    }`}
                                  onClick={() => this.handleToggle('is_service_charge_included')}
                                >
                                  <div className="toggle-slider"></div>
                                </div>
                              </div>
                              {this.state.is_service_charge_included && (
                                <div className="form-field" style={{ marginTop: '16px' }}>
                                  <label>{i18n.t('service_charge_included')} (%)</label>
                                  <input
                                    type="number"
                                    name="service_charge_included"
                                    value={this.state.service_charge_included}
                                    onChange={this.handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="e.g. 5"
                                    step="0.01"
                                    min="0"
                                    className={
                                      this.state.errors.service_charge_included ? 'error' : ''
                                    }
                                  />
                                  {this.renderFieldError('service_charge_included')}
                                </div>
                              )}

                              <div className="toggle-field">
                                <label>{i18n.t('service_charge_vat_included')}</label>
                                <div
                                  className={`toggle ${this.state.is_service_charge_vat_included ? 'active' : ''
                                    }`}
                                  onClick={() => this.handleToggle('is_service_charge_vat_included')}
                                >
                                  <div className="toggle-slider"></div>
                                </div>
                              </div>

                              <div className="toggle-field">
                                <label>{i18n.t('extra_time')}</label>
                                <div
                                  className={`toggle ${this.state.is_extra_time ? 'active' : ''}`}
                                  onClick={() => this.handleToggle('is_extra_time')}
                                >
                                  <div className="toggle-slider"></div>
                                </div>
                              </div>
                              {this.state.is_extra_time && (
                                <div className="form-field" style={{ marginTop: '16px' }}>
                                  <label>{i18n.t('extra_minutes')}</label>
                                  <input
                                    type="number"
                                    name="extra_time"
                                    value={this.state.extra_time}
                                    onChange={this.handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="e.g. 5"
                                    step="1"
                                    min="0"
                                    className={this.state.errors.extra_time ? 'error' : ''}
                                  />
                                  {this.renderFieldError('extra_time')}
                                </div>
                              )}

                              {/* Group Image Upload with Preview */}
                              <div className="upload-field">
                                <label>{i18n.t('upload_group_image')} *</label>
                                {this.state.previewImage ? (
                                  <div className="file-preview-container">
                                    <div className="image-preview">
                                      <img src={this.state.previewImage} alt="Group preview" />
                                      <div className="preview-actions">
                                        <button
                                          type="button"
                                          className="preview-action-btn"
                                          onClick={() => {
                                            this.setState({ showPreview: true });
                                          }}
                                          title="View full image"
                                        >
                                          <Eye size={16} />
                                        </button>
                                        <button
                                          type="button"
                                          className="preview-action-btn"
                                          onClick={() => {
                                            if (this.state.file_group_image) {
                                              this.removeFile('image');
                                            } else {
                                              this.removeExistingFile('image');
                                            }
                                          }}
                                          title="Remove image"
                                        >
                                          <X size={16} />
                                        </button>
                                      </div>
                                    </div>
                                    {this.state.file_group_image && (
                                      <div className="file-info">
                                        <span className="file-name">
                                          {this.state.file_group_image.name}
                                        </span>
                                        <span className="file-size">
                                          {(this.state.file_group_image.size / 1024).toFixed(2)} KB
                                        </span>
                                      </div>
                                    )}
                                    {!this.state.file_group_image &&
                                      this.state.existing_group_image &&
                                      (() => {
                                        const file = this.getFileInfo(
                                          this.state.existing_group_image
                                        );

                                        return (
                                          <div className="file-info">
                                            <span className="file-name">
                                              current-group.{file.extension}
                                            </span>
                                          </div>
                                        );
                                      })()}
                                  </div>
                                ) : (
                                  <div
                                    className={`upload-area ${this.state.errors.file_group_image ? 'error' : ''
                                      }`}
                                  >
                                    <input
                                      type="file"
                                      name="file_group_image"
                                      onChange={this.handleFileChange}
                                      accept="image/jpeg,image/jpg,image/png,image/gif"
                                      style={{ display: 'none' }}
                                      id="file_group_image"
                                    />
                                    <label
                                      htmlFor="file_group_image"
                                      style={{ cursor: 'pointer', width: '100%' }}
                                    >
                                      <div className="upload-icon">
                                        <Cloud size={24} strokeWidth={1} />
                                      </div>
                                      <p>
                                        <span className="upload-link">
                                          {i18n.t('upload_a_file')}
                                        </span>{' '}
                                        {i18n.t('or_drag_and_drop')}
                                      </p>
                                      <p className="upload-info">PNG, JPG, GIF up to 10MB</p>
                                    </label>
                                  </div>
                                )}
                                {this.renderFieldError('file_group_image')}
                              </div>

                              {/* Terms & Conditions Upload with Preview */}
                              <div className="upload-field">
                                <label>{i18n.t('upload_terms_and_conditioin')} *</label>
                                {this.state.file_terms || this.state.existing_terms ? (
                                  <div className="file-preview-container">
                                    <div className="document-preview">
                                      <div className="document-icon">
                                        <FileText size={24} strokeWidth={1.5} />
                                      </div>
                                      <div className="document-info">
                                        <span className="document-name">
                                          {this.state.file_terms
                                            ? this.state.file_terms.name
                                            : 'Terms & Conditions Document'}
                                        </span>
                                        {this.state.file_terms && (
                                          <span className="document-size">
                                            {(this.state.file_terms.size / 1024).toFixed(2)} KB
                                          </span>
                                        )}

                                        {!this.state.file_terms &&
                                          this.state.existing_terms &&
                                          (() => {
                                            const file = this.getFileInfo(
                                              this.state.existing_terms
                                            );

                                            return (
                                              <span className="file-name">
                                                current-terms.{file.extension}
                                              </span>
                                            );
                                          })()}
                                      </div>
                                      <div className="document-actions">
                                        <button
                                          type="button"
                                          className="preview-action-btn"
                                          onClick={() => {
                                            if (this.state.file_terms) {
                                              this.removeFile('terms');
                                            } else {
                                              this.removeExistingFile('terms');
                                            }
                                          }}
                                          title="Remove file"
                                        >
                                          <X size={16} />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className={`upload-area ${this.state.errors.file_terms ? 'error' : ''
                                      }`}
                                  >
                                    <input
                                      type="file"
                                      name="file_terms"
                                      onChange={this.handleFileChange}
                                      accept=".pdf,.doc,.docx"
                                      style={{ display: 'none' }}
                                      id="file_terms"
                                    />
                                    <label
                                      htmlFor="file_terms"
                                      style={{ cursor: 'pointer', width: '100%' }}
                                    >
                                      <div className="upload-icon">
                                        <FileText size={24} strokeWidth={1} />
                                      </div>
                                      <p>
                                        <span className="upload-link">
                                          {i18n.t('upload_a_file')}
                                        </span>{' '}
                                        {i18n.t('or_drag_and_drop')}
                                      </p>
                                      <p className="upload-info">PDF, DOCX up to 10MB</p>
                                    </label>
                                  </div>
                                )}
                                {this.renderFieldError('file_terms')}
                              </div>

                              {/* Payment Terms Upload with Preview */}
                              <div className="upload-field">
                                <label>{i18n.t('upload_paytment_terms')} *</label>
                                {this.state.file_payment_terms ||
                                  this.state.existing_payment_terms ? (
                                  <div className="file-preview-container">
                                    <div className="document-preview">
                                      <div className="document-icon">
                                        <FileText size={24} strokeWidth={1.5} />
                                      </div>
                                      <div className="document-info">
                                        <span className="document-name">
                                          {this.state.file_payment_terms
                                            ? this.state.file_payment_terms.name
                                            : 'Payment Terms Document'}
                                        </span>
                                        {this.state.file_payment_terms && (
                                          <span className="document-size">
                                            {(this.state.file_payment_terms.size / 1024).toFixed(2)}{' '}
                                            KB
                                          </span>
                                        )}

                                        {!this.state.file_payment_terms &&
                                          this.state.existing_terms &&
                                          (() => {
                                            const file = this.getFileInfo(
                                              this.state.existing_terms
                                            );

                                            return (
                                              <span className="file-name">
                                                current-payment.{file.extension}
                                              </span>
                                            );
                                          })()}
                                      </div>
                                      <div className="document-actions">
                                        <button
                                          type="button"
                                          className="preview-action-btn"
                                          onClick={() => {
                                            if (this.state.file_payment_terms) {
                                              this.removeFile('payment_terms');
                                            } else {
                                              this.removeExistingFile('payment_terms');
                                            }
                                          }}
                                          title="Remove file"
                                        >
                                          <X size={16} />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className={`upload-area ${this.state.errors.file_payment_terms ? 'error' : ''
                                      }`}
                                  >
                                    <input
                                      type="file"
                                      name="file_payment_terms"
                                      onChange={this.handleFileChange}
                                      accept=".pdf,.doc,.docx"
                                      style={{ display: 'none' }}
                                      id="file_payment_terms"
                                    />
                                    <label
                                      htmlFor="file_payment_terms"
                                      style={{ cursor: 'pointer', width: '100%' }}
                                    >
                                      <div className="upload-icon">
                                        <FileText size={24} strokeWidth={1} />
                                      </div>
                                      <p>
                                        <span className="upload-link">
                                          {i18n.t('upload_a_file')}
                                        </span>{' '}
                                        {i18n.t('or_drag_and_drop')}
                                      </p>
                                      <p className="upload-info">PDF, DOCX up to 10MB</p>
                                    </label>
                                  </div>
                                )}
                                {this.renderFieldError('file_payment_terms')}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="action-buttons-l2 border-top-light">
                          <button
                            className="button1 button1-gray"
                            onClick={this.handleCancel}
                            disabled={this.state.isSubmitting}
                          >
                            {i18n.t('cancel')}
                          </button>
                          <button
                            className="button1 button1-primary"
                            onClick={this.handleSubmit}
                            disabled={this.state.isSubmitting}
                          >
                            {this.state.isSubmitting ? (
                              <>
                                <Loader2 className="animate-spin" size={18} />
                                <span>{i18n.t('update_group')}</span>
                              </>
                            ) : (
                              <span>{i18n.t('update_group')}</span>
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <PreviewModal
          show={showPreview}
          previewImage={previewImage}
          onClose={() => this.setState({ showPreview: false })}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(GroupUpdate);
